/**
 * <details-disclosure> — wraps a <details>/<summary> dropdown (desktop mega
 * menu, small popovers). The open/close state is 100% native `<details>`;
 * this only adds: closing when focus/click leaves, closing siblings so two
 * dropdowns can't be open at once, and syncing aria-expanded.
 */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    if (!this.details || !this.summary) return;

    this.summary.setAttribute('aria-expanded', 'false');
    this.details.addEventListener('toggle', this.onToggle.bind(this));
    document.addEventListener('click', this.onOutsideClick.bind(this));
  }

  onToggle() {
    this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
    if (this.details.open) this.closeSiblings();
  }

  closeSiblings() {
    document.querySelectorAll('details-disclosure details[open]').forEach((el) => {
      if (el !== this.details) el.removeAttribute('open');
    });
  }

  onOutsideClick(event) {
    if (!this.details.open) return;
    if (this.contains(event.target)) return;
    this.details.removeAttribute('open');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
